"use client"

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"
import { Manrope } from "next/font/google"

const manrope = Manrope({
    subsets: ["latin"],
    weight: ["400", "500", "600", "700", "800"],
})

interface ModalDesktopProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    title: string
    description?: string
    children: React.ReactNode
    trigger?: React.ReactNode
    maxWidth?: string
    contentClassName?: string 
}

export function ModalDesktop({
    open,
    onOpenChange,
    title,
    description,
    children,
    trigger,
    maxWidth = "md:max-w-[600px]",
    contentClassName = "" 
}: ModalDesktopProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
            {/*  MASUKKAN manrope.className KE DALAM DialogContent */}
            <DialogContent className={`${manrope.className} ${maxWidth} max-h-[90vh] dark:bg-gray-800 translate-y-[-45vh] sm:translate-y-[-45vh]`}>
                <DialogHeader>
                    <DialogTitle className="text-xl text-center font-bold">{title}</DialogTitle>
                    {description && (
                        <DialogDescription className="text-gray-600 dark:text-gray-400">
                            {description}
                        </DialogDescription>
                    )}
                </DialogHeader>
                <div
                    data-modal-scroll
                    className={`${contentClassName || 'flex-1 overflow-y-auto'}`}
                >
                    {children}
                </div>
            </DialogContent>
        </Dialog>
    )
}